module.exports = __webpack_public_path__ + "static/media/245.aa4a4cea.webp";